import { css, cx } from '@emotion/css';
import { Oval } from 'react-loader-spinner';
import { Colors } from '../styles/colors';

interface LoaderProps {
  className?: string;
}

export const Loader = (props: LoaderProps): JSX.Element => {
  const { className } = props;
  return (
    <Oval
      ariaLabel="loading-indicator"
      color={Colors.CAPRI_BLUE}
      secondaryColor={`${Colors.CAPRI_BLUE}33`}
      strokeWidth={4}
      height={44}
      width={44}
      wrapperClass={cx(loaderStyle, className)}
    />
  );
};

const loaderStyle = css`
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
`;
